@if (selectedSize() === visualsDashboardWidgetSizingEnum.SMALL) {
    <div class="row-container small">
        <app-ice-visuals-dashboard-pie-chart
            [segments]="sizeScoreByListingsSegments()"
            [centerLabel]="sizeScoreByListingsCenterLabel()"
            [loading]="dataService.loading()"
            [variant]="pieChartVariantEnum.SMALL"
        >
            <span chartFooter>{{ 'dashboard.visuals.components.general.average' | translate: { averageSize: averageSize() } }}</span>
        </app-ice-visuals-dashboard-pie-chart>
    </div>
} @else if (selectedSize() === visualsDashboardWidgetSizingEnum.MEDIUM_ROW) {
    <app-ice-visuals-dashboard-pie-chart
        [segments]="sizeScoreByListingsSegments()"
        [centerLabel]="sizeScoreByListingsCenterLabel()"
        [valueColumnHeader]="'dashboard.visuals.widgets.sizeScoreByListings.tableLabel' | translate"
        [loading]="dataService.loading()"
        [variant]="pieChartVariantEnum.LARGE"
    >
        <span chartFooter>{{ 'dashboard.visuals.components.general.average' | translate: { averageSize: averageSize() } }}</span>
    </app-ice-visuals-dashboard-pie-chart>
}
